<script>
export default {
  name: "ReportPageBreaker",
  props: {
    slug: {
      type: String,
      required: true
    },
    description: {
      type: String,
      required: true
    },
    primaryColor: {
      type: String,
      required: true
    },
    secondaryColor: {
      type: String,
      required: true
    },
    descriptionTextColor: {
      type: String,
      required: true
    }
  }
}
</script>

<template>
  <div class="breaker-container" :style="{backgroundColor: primaryColor}">
    <div class="title-description">
      <span class="parameter-title">
        {{ $t(`checkup_plus.reports.patient_overall_summary.${slug}`)}}
      </span>
      <br>
        <span class="parameter-description" :style="{color: descriptionTextColor}">
        {{description}}
      </span>

    </div>
    <div class="ellipsis" :style="{backgroundColor: secondaryColor}">
      <img :src="require(`@/assets/check-up-reports/evollu-default/${slug}.svg`)" alt="Image">
    </div>
  </div>
</template>

<style scoped lang="scss">
.breaker-container {
  width: 100%;
  height: 100px;
  position: absolute;
  margin-left: -20px;
  display: flex;
  align-items: center;
  overflow: hidden;
  color: white;
  background-size: cover;
}

.ellipsis {
  width: 25%;
  height: 200%;
  position: absolute;
  right: 0;
  border-top-left-radius: 100px;
  border-bottom-left-radius: 100px;
  display: flex;
  align-items: center;
  justify-content: center;

  img {
    height: 70px;
  }
}

.title-description {
  margin-left: 10px;

  .parameter-title {
    font-weight: bold;
    font-size: 20px;
  }

  .parameter-description {
    font-size: 14px;
  }
}
</style>
